import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './BitterGourdPage.css';
import bittergourdLogo from '../images/bittergourd-logo.png';
import dhruva from '../images/bittergourd-dhruva.png';
import ds1035 from '../images/bittergourd-ds1035-img.png';
import roshani from '../images/bittergourd-roshani-img.png';
import vishal459 from '../images/bittergourd-vishal459-img.png';
import indhu from "../images/bittergourd-indhu-img.png"

const varieties = [
  {
    name: 'INDHU',
    image: indhu,
    description: [
      'Dynasty Agriseeds F1 Hybrid - High-yielding hybrid with high vigor and high productivity',
      'Yields average around 15 tons per acre under good management',
      'Early maturity: First picking typically occurs within 60–65 days of sowing',
      'Fruit Characteristics: Dark green, half-long with noticeable spines',
      'Fruit dimensions: 16-18 cm in length, weighing approximately 100-130 g',
      'Resistance: Intermediate resistance to powdery mildew with field tolerance to viruses',
      'Adaptability: Strong ability to remain green and productive even under environmental stress',
      'Market Appeal: Excellent for long-distance transport due to good fruit firmness',
      'Sowing season: Suitable for both rainy and summer seasons',
    ],
  },
  {
    name: 'DHRUVA',
    image: dhruva,
    description: [
      'High yielding hybrid with good crop longevity',
      'Suitable for long distance shipping',
      'Produces attractive dark green fruits with more market price',
      'Plant type: Strong and sturdy vines',
      'Fruit colour: Dark green',
      'Fruit shape: Spindle shaped and small',
      'Fruit length: 7-9 cm',
      'Sowing season: Kharif, Rabi and Summer',
      'Method of sowing: Dibbling',
      'First harvest: 50-55 days',
    ],
  },
  {
    name: 'DS-1035',
    image: ds1035,
    description: [
      'High yielding hybrid with good crop longevity',
      'Suitable for long distance shipping',
      'Produces attractive dark green fruits with more market price',
      'Plant type: Strong and sturdy vines',
      'Fruit colour: Dark green',
      'Fruit shape: Spindle shaped and small',
      'Fruit length: 11-12 cm',
      'Sowing season: Kharif, Rabi and Summer',
      'Method of sowing: Dibbling',
      'First harvest: 50-55 days',
    ],
  },
  {
    name: 'ROSHANI',
    image: roshani,
    description: [
      'Dark green fruits with continuous blunt spines',
      'Better acceptability in the market due to attractive shape and spine pattern',
      'Good keeping quality',
      'High yield and consistent performer',
      'Yellow mosaic virus resistant',
      'Fruit weight: 80-90 gm',
      'Length: 12-14 cm',
      'Maturity: 52-55 days',
    ],
  },
  {
    name: 'VISHAL-459',
    image: vishal459,
    description: [
      'High yielding hybrid',
      'Intermediate resistance to powdery mildew and field tolerance to virus',
      'Ability to stay green even during higher stress',
      'Plant type: Highly vigorous vines',
      'Type: Half long spiny',
      'Fruit colour: Dark green',
      'Fruit shape: Medium long spine',
      'Fruit length: 16-19 cm',
      'Fruit weight: 100-120 gm',
    ],
  },
  
  
];

export default function BitterGourdPage() {
  return (
    <ProductPatternPage
      title="Bitter Gourd"
      varieties={varieties}
      pageClass="bittergourd-page"
      heroImage={bittergourdLogo}
    />
  );
}
